import React from "react";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { siteData } from "../mock";

export default function PainPoints() {
  return (
    <section className="bg-gradient-to-br from-[#f5ead9] to-[#f9dcc6] py-24">
      <div className="container-tight grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="rounded-[2rem] overflow-hidden aspect-[4/5]">
            <img
              src={siteData.hero.heroImage2}
              alt="Soin de fasciathérapie méthode Tissual Balancing à Saint-Orens"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-white rounded-2xl p-6 max-w-xs shadow-xl border border-[#eee5d6]">
            <p className="font-serif text-xl leading-tight text-[#2b2620]">
              "Je me sens tellement léger, c'est incroyable."
            </p>
            <p className="text-xs text-[#8a7d6a] mt-3">— Témoignage récurrent</p>
          </div>
        </div>

        <div>
          <span className="chip mb-6">Bien-être & équilibre</span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium tracking-tight leading-[1.05] text-[#2b2620]">
            Et si vos douleurs n'étaient pas une fatalité ?
          </h2>
          <ul className="mt-8 space-y-4">
            {siteData.painPoints.map((p, i) => (
              <li key={p} className="flex items-start gap-3">
                <CheckCircle2 size={22} className="text-[#c76d4b] flex-shrink-0 mt-0.5" />
                <span className="text-[#5c554c] leading-relaxed">{p}</span>
              </li>
            ))}
          </ul>
          <p className="mt-8 italic text-[#8a7d6a]">
            Une prise en charge adaptée alliant fasciathérapie et coaching sport santé peut vous aider à retrouver mobilité et bien-être durablement.
          </p>
          <a
            href="https://www.resalib.fr/praticien/120570-jean-christophe-happillon-fasciatherapeute-quint-fonsegrives"
            target="_blank"
            rel="noreferrer"
            className="btn-primary mt-8"
          >
            Prendre rendez-vous <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
